var render = function render(){var _vm=this,_c=_vm._self._c;return _c('prompt',{attrs:{"title":_vm.$t(`title`),"label":_vm.$t(`pleaseEnterPhoneNumber`),"defaultValue":_vm.phoneNumber,"inputType":"number","validator":_vm.validator,"placeholder":"ex. 0912345678"},on:{"confirm":v => _vm.setOrderParams({ phoneNumber: v })}})
}
var staticRenderFns = []

export { render, staticRenderFns }